const flatten = (nodes, out = []) => {
  for (const n of nodes ?? []) {
    out.push(n);
    if (n.children?.length) flatten(n.children, out);
  }
  return out;
};

/**
 * Resolve the active org filter to real org ids WITHOUT expanding a selected
 * node to its descendants — unlike hierarchy-picker's resolveOrgIds (used by
 * the ESG Dashboard), Target Setup Overview and its Excel Export treat an
 * org-filter selection as scoping to exactly the picked org(s), not its
 * subtree. The synthetic "country:<name>" filter id isn't a real org id, so
 * it still expands to every org whose country matches.
 */
export const resolveOrgIdsExact = (orgIds = [], tree = []) => {
  if (!orgIds?.length) return [];

  const out = new Set();
  for (const id of orgIds) {
    if (typeof id === "string" && id.startsWith("country:")) {
      const country = id.slice("country:".length);
      for (const n of flatten(tree)) {
        if (n.country === country) out.add(String(n.id));
      }
    } else {
      out.add(String(id));
    }
  }
  return [...out];
};
